module.exports = __webpack_public_path__ + "static/img/env27.f80ade4.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env27.png
// module id = 117
// module chunks = 4